"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var jdStoreApi = _interopRequireWildcard(require("@/api/jdStoreApi"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'JdPriceRecordDialog',
  data: function data() {
    return {
      visible: false,
      listLoading: false,
      recordList: [],
      total: 0,
      currentRow: null,
      pageParams: {
        page: 1,
        limit: 10
      }
    };
  },
  methods: {
    open: function open(row) {
      this.currentRow = row;
      this.pageParams = {
        page: 1,
        limit: 10
      };
      this.visible = true;
      this.fetchRecordList();
    },
    fetchRecordList: function fetchRecordList() {
      var _this = this;
      this.listLoading = true;
      var params = _objectSpread({
        categoryId: this.currentRow.categoryId
      }, this.pageParams);
      jdStoreApi.getJdPriceAdjustRecords(params).then(function (res) {
        _this.recordList = res.list || [];
        _this.total = res.total || 0;
      }).catch(function () {
        _this.recordList = [];
        _this.total = 0;
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    getRatioText: function getRatioText(ratio) {
      if (ratio == null) return '--';
      return (ratio > 0 ? '+' : '') + ratio + '%';
    },
    getRatioClass: function getRatioClass(ratio) {
      if (ratio == null) return '';
      if (ratio > 0) return 'ratio-up';
      if (ratio < 0) return 'ratio-down';
      return '';
    },
    handlePageChange: function handlePageChange(page) {
      this.pageParams.page = page;
      this.fetchRecordList();
    },
    handleSizeChange: function handleSizeChange(limit) {
      this.pageParams.limit = limit;
      this.pageParams.page = 1;
      this.fetchRecordList();
    },
    handleClose: function handleClose() {
      this.visible = false;
      this.recordList = [];
      this.total = 0;
      this.currentRow = null;
    }
  }
};